import { apiClient } from '../../axios';
import { GetKycAccessTokenParams, GetKycAccessTokenResponse, GetUserKYCIdentityResponse, UserKycStatus } from './types';

export const getKycAccessTokenApi = (params: GetKycAccessTokenParams) =>
  apiClient.post<GetKycAccessTokenResponse>('/v1/user/kyc/access-token', params);

export const getCurrentKYCStatusApi = () => apiClient.get<UserKycStatus>('/v1/user/kyc/status');

export const getUserKYCIdentityApi = () => apiClient.get<GetUserKYCIdentityResponse>('/v1/user/kyc/identity');
